import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import MobileDistributionsTable from './MobileDistributionsTable';
import DistributionsTable from './DistributionsTable';

export default function TotalAmountTable({
  distributionData, distributionLabel, showUnPaidDistributions, fundCode,
  fundTotalDistributions, year,
}) {
  const theme = useTheme();
  const desktopSize = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <>
      {desktopSize
        ? (
          <DistributionsTable
            distributionData={distributionData}
            distributionLabel={distributionLabel}
            showUnPaidDistributions={showUnPaidDistributions}
            fundCode={fundCode}
            fundTotalDistributions={fundTotalDistributions}
          />
        )
        : (
          <MobileDistributionsTable
            distributionData={distributionData}
            distributionLabel={distributionLabel}
            showUnPaidDistributions={showUnPaidDistributions}
            fundCode={fundCode}
            fundTotalDistributions={fundTotalDistributions}
            year={year}
          />
        )}
    </>
  );
}

TotalAmountTable.propTypes = {
  distributionData: PropTypes.arrayOf(PropTypes.object).isRequired,
  distributionLabel: PropTypes.string,
  showUnPaidDistributions: PropTypes.bool.isRequired,
  fundCode: PropTypes.string,
  fundTotalDistributions: PropTypes.string,
  year: PropTypes.number,
};

TotalAmountTable.defaultProps = {
  distributionLabel: '',
  fundCode: '',
  fundTotalDistributions: '',
  year: undefined,
};
